exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.missBox[data-v-fbc19a8e] {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  margin-top: 0;\n  z-index: 10;\n  padding-top: 2.5rem;\n}\n.missBox > img[data-v-fbc19a8e] {\n  width: 3.5rem;\n  height: 3.5rem;\n}\n.missBox .btn[data-v-fbc19a8e] {\n  width: 4.8rem;\n  height: 1.28rem;\n  border-radius: 0.21rem;\n  margin: 0 auto;\n  margin-top: 1.5rem;\n}\n", ""]);

// exports
